"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormattedNumber["default"];
  }
});
var _FormattedNumber = _interopRequireDefault(require("./FormattedNumber"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }